// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"30c54c76","453":"9415623e","857":"36a34cd9","985":"c4984874"}[chunkId] + ".chunk.js";
};